import React from 'react'
import TextField, { TextFieldProps } from '@mui/material/TextField'
import ukLocale from 'date-fns/locale/uk'
import { CalendarPickerView, DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'

interface PropsType {
  id?: string
  label?: string
  value?: Date | null
  error?: boolean
  required?: boolean
  style?: React.CSSProperties | undefined
  className?: string
  views?: CalendarPickerView[]
  mask?: string
  inputFormat?: string
  onChange: (value: Date | null) => void
}

const BasicDatePicker: React.FC<PropsType> = ({
  id,
  value,
  required,
  className,
  onChange,
  label,
  style,
  error,
  inputFormat = 'dd/MM/yyyy',
  mask = '__/__/____',
  views = ['year', 'month', 'day'],
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ukLocale}>
      <DatePicker
        mask={mask}
        inputFormat={inputFormat}
        label={label}
        views={views}
        value={value}
        className={className}
        onChange={onChange}
        renderInput={(params: JSX.IntrinsicAttributes & TextFieldProps) => (
          <TextField
            id={id}
            name={id}
            style={style}
            fullWidth
            required={required}
            error={error}
            size='small'
            {...params}
          />
        )}
      />
    </LocalizationProvider>
  )
}

export default BasicDatePicker
